// App.jsx
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"
import { Suspense } from "react"
import templateRegistry from "Components/templateRegistry"
import { useEffect } from "react"
import Layout from "Layout/layout"
import ToastProvider from "UI/Toast/toastProvider"
import ErrorBoundary from "UI/Boundary/errorBoundary"
import PageCrash from "UI/Boundary/pageCrash"
import PageProgress from "UI/Loading/pageProgress"
import PageSkeleton from "UI/Loading/pageSkeleton"
import queryClient from "Api/queryClient"
import { QueryClientProvider } from "@tanstack/react-query"
import { AuthProvider } from "Auth/authContext"
import ProtectedRoute from "Auth/protectedRoute"
import NotFound from "UI/Elements/notFound"
import { HelmetProvider } from "react-helmet-async"

//Site to load
import siteConfig from "Components/Sites/stratapoints"

const AppRoutes = () => {
	const location = useLocation()
	return (
		<>
			<PageProgress />
			<Routes>
				{siteConfig.pages.map((page) => {
					if (page.component) {
						const Component = page.component
						return (
							<Route
								key={page.path}
								path={page.path}
								element={
									<ErrorBoundary key={location.pathname} fallback={<PageCrash />}>
										<Suspense fallback={<PageSkeleton />}>
											{page.protected ? (
												<ProtectedRoute>
													<Component />
												</ProtectedRoute>
											) : (
												<Component />
											)}
										</Suspense>
									</ErrorBoundary>
								}
							/>
						)
					}
					const Template = templateRegistry[page.template]
					if (!Template) {
						console.warn(`[Router] No template registered for: "${page.template}"`)
						return null
					}
					return (
						<Route
							key={page.path}
							path={page.path}
							element={
								<ErrorBoundary key={location.pathname} fallback={<PageCrash />}>
									<Suspense fallback={<PageSkeleton />}>
										{page.protected ? (
											<ProtectedRoute>
												<Template {...page.props} seo={page.seo} />
											</ProtectedRoute>
										) : (
											<Template {...page.props} seo={page.seo} />
										)}
									</Suspense>
								</ErrorBoundary>
							}
						/>
					)
				})}
				<Route path="*" element={<NotFound />} />
			</Routes>
		</>
	)
}

const App = () => {
	useEffect(() => {
		document.documentElement.setAttribute("data-theme", siteConfig.theme)
		return () => document.documentElement.removeAttribute("data-theme")
	}, [])

	return (
		<HelmetProvider>
			<QueryClientProvider client={queryClient}>
				<BrowserRouter>
					<AuthProvider>
						<Layout layout={siteConfig}>
							<ToastProvider />
							<AppRoutes />
						</Layout>
					</AuthProvider>
				</BrowserRouter>
			</QueryClientProvider>
		</HelmetProvider>
	)
}

export default App
